import classNames from 'classnames';
import React from 'react';
import { CellWrapper } from "./Cell.styles";

var defaultComponent = function defaultComponent(_ref) {
  var value = _ref.value;
  var text = [undefined, null].includes(value) ? '' : value.toString();
  return React.createElement("span", null, text);
};

export var Cell = function Cell(_ref2) {
  var className = _ref2.className,
      component = _ref2.component,
      colSpan = _ref2.colSpan,
      value = _ref2.value,
      data = _ref2.data,
      groupHeader = _ref2.groupHeader,
      style = _ref2.style;
  var Component = component || defaultComponent;
  return React.createElement(CellWrapper, {
    className: classNames('table__body-cell', className),
    style: style,
    colSpan: colSpan,
    groupHeader: groupHeader
  }, React.createElement(Component, {
    value: value,
    data: data
  }));
};